<div
    [ngStyle]="{ 
        width: loaderWidth(), 
        height: loaderHeight(), 
        'border-width': borderWidth(),
        'border-color': borderColor(), 
        'border-top-color': 'transparent'}"
    class="rounded-full border-solid animate-spin">
</div>